import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext"; // Adjust path

interface PrivateRouteProps {
  children: ReactNode;
}

function PrivateRoute({ children }: PrivateRouteProps): React.JSX.Element {
  const { currentUser } = useAuth();

  return currentUser ? <>{children}</> : <Navigate to="/login" />; // Use React Fragment for children
}

export default PrivateRoute;
